(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(){
    var revealEls = document.querySelectorAll('.gv-reveal, .gv-reveal-scale');
    if(!revealEls.length) return;
    if(reduced || !('IntersectionObserver' in window)){
      revealEls.forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function(el){ io.observe(el); });
  }

  function animateCount(el){
    var target = parseInt(el.getAttribute('data-count-to'), 10);
    var suffix = el.getAttribute('data-suffix') || '';
    if(reduced || isNaN(target)){ el.textContent = (isNaN(target) ? el.textContent : target + suffix); return; }
    var start = null, duration = 1200;
    function step(ts){
      if(!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      el.textContent = Math.floor(progress * target) + suffix;
      if(progress < 1) requestAnimationFrame(step);
      else el.textContent = target + suffix;
    }
    requestAnimationFrame(step);
  }

  function initCounters(){
    var counters = document.querySelectorAll('.gv-metric-value[data-count-to]');
    if(!counters.length) return;
    if('IntersectionObserver' in window){
      var cio = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){ animateCount(entry.target); cio.unobserve(entry.target); }
        });
      }, { threshold: 0.5 });
      counters.forEach(function(el){ cio.observe(el); });
    } else {
      counters.forEach(function(el){ animateCount(el); });
    }
  }

  function initRipple(){
    document.querySelectorAll('.gv-btn').forEach(function(btn){
      btn.addEventListener('click', function(e){
        if(reduced) return;
        var rect = btn.getBoundingClientRect();
        var ripple = document.createElement('span');
        ripple.className = 'gv-ripple';
        var size = Math.max(rect.width, rect.height);
        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = (e.clientX - rect.left - size/2) + 'px';
        ripple.style.top = (e.clientY - rect.top - size/2) + 'px';
        btn.appendChild(ripple);
        setTimeout(function(){ ripple.remove(); }, 500);
      });
    });
  }

  function initCookieBanner(){
    var banner = document.getElementById('gvCookieBanner');
    if(!banner) return;
    try {
      if(localStorage.getItem('gv_cookie_consent')){
        banner.classList.add('gv-hidden');
        return;
      }
    } catch(e) { /* storage unavailable, banner just won't persist dismissal */ }
    var accept = document.getElementById('gvCookieAccept');
    var decline = document.getElementById('gvCookieDecline');
    function dismiss(value){
      banner.classList.add('gv-hidden');
      try { localStorage.setItem('gv_cookie_consent', value); } catch(e) {}
    }
    if(accept) accept.addEventListener('click', function(){ dismiss('accepted'); });
    if(decline) decline.addEventListener('click', function(){ dismiss('declined'); });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initReveal();
    initCounters();
    initRipple();
    initCookieBanner();
  });
})();
